import { useLocation } from 'react-router-dom';

export const useCurrentQuestionId = (): number => {
    const { pathname } = useLocation();
    const questionNumber = pathname.split('/').pop();

    // TODO: Better handling if /quiz/asd
    return Number(questionNumber);
};
